<style lang="postcss">
	.input-email-cover {
		display: flex;
		align-items: center;
	}
</style>

<script lang="ts">
	import { getContext } from "svelte";
	import type { Writable } from "svelte/store";
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";
	import Input from "$form/Fields/Shared/Input.svelte";
	import { createEventDispatcher, onMount } from "svelte";

	let inputRef: HTMLInputElement;
	const styling = getContext<Styling>("styling");
	const remoteValidation =
		getContext<Writable<RemoteValidation[]>>("remoteValidation");
	$: remoteValidItem = $remoteValidation.find(
		(item) => item.field_id === field.id
	);

	export let field: FieldDisplay & { type: "Email" };
	export let value: string;

	const dispatch = createEventDispatcher();
	const suffixIcon: Embed = {
		key: "msl-alternate-email",
		type: "inline_svg",
		content: `<svg width="21" height="21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path fill="currentColor" d="M12 21q-1.863 0-3.507-.708q-1.643-.709-2.859-1.924q-1.216-1.214-1.925-2.856Q3 13.87 3 12.003q0-1.866.708-3.51q.709-1.643 1.924-2.859q1.214-1.216 2.856-1.925Q10.13 3 11.997 3q1.866 0 3.51.709t2.859 1.924q1.216 1.215 1.925 2.857Q21 10.133 21 12v.988q0 1.264-.868 2.138Q19.264 16 18 16q-.894 0-1.63-.49q-.737-.49-1.09-1.306q-.57.821-1.425 1.309Q13 16 12 16q-1.671 0-2.836-1.164T8 12q0-1.671 1.164-2.836T12 8q1.671 0 2.836 1.164T16 12v.988q0 .824.588 1.418Q17.177 15 18 15t1.412-.594q.588-.594.588-1.418V12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20h5v1zm0-6q1.25 0 2.125-.875T15 12q0-1.25-.875-2.125T12 9q-1.25 0-2.125.875T9 12q0 1.25.875 2.125T12 15" stroke="currentColor" stroke-width="0.3"/></svg>`
	};

	onMount(() => {
		inputRef.addEventListener("focus", () => {
			dispatch("updateOther", {
				active: true
			});
		});
		inputRef.addEventListener("blur", () => {
			dispatch("updateOther", {
				tainted: true
			});
			dispatch("updateOther", {
				active: false
			});
		});
	});
</script>

<div
	class="field-label-cover"
	class:has-placeholder="{styling.placeholders !== false}">
	{#if field.labelHTMLComputed && field.settings.hideLabel !== true}
		{#if styling.placeholders === false}
			<Label html="{field.labelHTMLComputed}" />
		{/if}
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	<div class="input-email-cover">
		<Input
			bind:value="{value}"
			bind:element="{inputRef}"
			name="{field.id}"
			label="{field.labelComputed}"
			placeholder="{styling.placeholders
				? field.labelComputed
				: (field.styling?.placeholder ?? '')}"
			suffixIcon="{suffixIcon}"
			loading="{remoteValidItem?.state === 'loading'}"
			suffixOverwrite="{remoteValidItem?.state ?? null}"
			type="email" />
	</div>
	{#if remoteValidItem && remoteValidItem?.state === "invalid"}
		<FieldError
			valid="{false}"
			errorNumber="{0}"
			visible="{true}"
			errorType="{remoteValidItem.errorType}" />
	{:else}
		<FieldError
			visible="{field.tainted}"
			valid="{field.valid}"
			errorNumber="{field.errorNumber}"
			errorType="{field.errorType}" />
	{/if}
</div>
